var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BasePlaceOrderButton',{staticClass:"nextStep",attrs:{"loading":_vm.loading,"loadingText":"提交中...","type":"danger","text":"提交","disabled":_vm.isDisabled,"params":_vm.params,"click":_vm.nextStep}})
}
var staticRenderFns = []

export { render, staticRenderFns }